<template>
  <div id="PageGhgCalculator">
    <SectionCalculator />
    <SectionComplexity />
    <SectionCSRD />
  </div>
</template>

<script setup lang="ts">
import SectionCSRD from '@/views/components/sections/SectionCSRD.vue'
import SectionComplexity from '@/views/components/sections/SectionComplexity.vue'
import SectionCalculator from './sections/SectionCalculator.vue'
import { useSeo, getBreadcrumbStructuredData } from '@/composables/useSeo'
import { getSeoConfig } from '@/config/seo'

// SEO Configuration
useSeo(
  getSeoConfig('ghgCalculator'),
  getBreadcrumbStructuredData([
    { name: 'Home', url: 'https://sustainalyse.com/' },
    { name: 'GHG Calculator', url: 'https://sustainalyse.com/ghg-calculator' }
  ])
)
</script>

<style lang="scss" scoped>
#PageGhgCalculator {
  min-height: 100vh;
}
</style>
